import styled from "@emotion/styled";
import Colors from "styles/colors";
import { BACKGROUND_GRAY_COLOR_NAME, GRAPHITE_GRAY_COLOR_NAME } from "styles/color-consts";
export const StyledLocationFilters = styled.div`
   .dropdown-menu-button {
     width: 140px;
   }

  .location-item {
    cursor: pointer;
    color: ${Colors[GRAPHITE_GRAY_COLOR_NAME]};
    position: relative;
    flex-wrap: wrap;
    flex-basis: 25%;
    box-sizing: border-box;
    gap: 12px;
    align-items: center;
    display: flex;
    padding: 8px 0 8px 10px;
    font-size: 0.875rem;
    line-height: 22px;
    border-radius: 4px;

    &:hover, &.is-active {
      background-color: ${Colors[BACKGROUND_GRAY_COLOR_NAME]};
    }

    .details {
      display: flex;
      flex-direction: column;
      gap: 4px;

      .location {
        font-size: 0.875rem;
        font-weight: 400;
      }

      .number-of-positions {
        font-size: 0.75rem;
      }
    }
  }
`;
